<div class="not-found">
  
    <h2 class="sub-header">{{'notFound.subtitle'|translate}}</h2>
    <p>{{'notFound.message' |translate}}</p>
    <a routerLink="/home">{{'notFound.link'|translate}}</a>
</div>